var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 12.713l-11.985-9.713h23.97l-11.985 9.713zm0 2.574l-12-9.725v15.438h24v-15.438l-12 9.725z"}));
}

Email.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Email;

Email.default = Email;
